export default __webpack_public_path__ + "static/media/021-sea cow.9ac59368.svg";